import type { ChangelogEntry } from "../types";

/** Tilgangene hentes først når innloggingen er klar. */
export const INNLOGGING_HJELP_2026_10: ChangelogEntry = {
  id: "2026-10-26-innlogging-hjelp",
  date: "2026-10-26",
  title: "Du havner ikke lenger på Hjelp etter innlogging",
  summary:
    "På en treg maskin eller et tregt nett kunne Revehiet hente tilgangene dine før innloggingen var klar, og da ble du sendt til Hjelp i stedet for forsiden.",
  sections: [
    {
      heading: "Innlogging",
      items: [
        {
          title: "Tilgangene venter på innloggingen",
          kind: "rettet",
          body: "Menyen, funksjonsbryterne og brukerlista hentes først når du er logget inn. Før kunne de feile hvis siden lastet sakte, og da viste menyen feil valg og forsiden sendte deg til Hjelp.",
        },
      ],
    },
  ],
};
